import { createElement } from '@syncfusion/ej2-base';
import { MS_PER_DAY, capitalizeFirstWord } from '../base/util';
/**
 * timeline header rows
 */
export class TimelineHeaderRow {
    constructor(parent, renderDates) {
        this.parent = parent;
        this.renderDates = renderDates;
    }
    groupByYear(dates) {
        const result = {};
        for (const d of dates) {
            const key = d.getFullYear();
            result[parseInt(key.toString(), 10)] = result[parseInt(key.toString(), 10)] || [];
            result[parseInt(key.toString(), 10)].push(d);
        }
        return result;
    }
    groupByMonth(dates) {
        const result = {};
        for (const d of dates) {
            const key = (d.getFullYear() - 1970) * 12 + d.getMonth();
            result[parseInt(key.toString(), 10)] = result[parseInt(key.toString(), 10)] || [];
            result[parseInt(key.toString(), 10)].push(d);
        }
        return result;
    }
    groupByWeek(dates) {
        const result = {};
        for (const d of dates) {
            const jsDate = +new Date(1970, 0, 1);
            const tzOffsetDiff = d.getTimezoneOffset() - new Date(1970, 0, 1).getTimezoneOffset();
            let key = Math.ceil(((((+d - jsDate) - (tzOffsetDiff * 60 * 1000)) / MS_PER_DAY) + new Date(jsDate).getDay() + 1) / 7);
            if (this.parent.activeViewOptions.firstDayOfWeek && this.parent.activeViewOptions.firstDayOfWeek > new Date(+d).getDay()) {
                key = key - 1;
            }
            result[parseInt(key.toString(), 10)] = result[parseInt(key.toString(), 10)] || [];
            result[parseInt(key.toString(), 10)].push(d);
        }
        return result;
    }
    generateSlots(data, colspan, row, cls, type) {
        const dateParser = (date, format) => this.parent.globalize.formatDate(date, { format: format, calendar: this.parent.getCalendarMode() });
        const tdDatas = [];
        const keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            const dates = data[keys[parseInt(i.toString(), 10)]];
            let htmlCol;
            if (row.template) {
                const args = { date: dates[0], type: type };
                const templateId = this.parent.element.id + '_headerRowTemplate';
                htmlCol = [].slice.call(this.parent.templateParser(row.template)(args, this.parent, 'template', templateId, false));
            }
            else {
                let viewTemplate;
                switch (row.option) {
                    case 'Year':
                        viewTemplate = `<span class="e-header-year">${dateParser(dates[0], 'y')}</span>`;
                        break;
                    case 'Month':
                        viewTemplate = `<span class="e-header-month">${capitalizeFirstWord(dateParser(dates[0], 'MMMM'), 'single')}</span>`;
                        break;
                    case 'Week':
                        viewTemplate = `<span class="e-header-week">${this.parent.getWeekNumberContent(dates)}</span>`;
                }
                const headerWrapper = createElement('div', { innerHTML: viewTemplate });
                htmlCol = [].slice.call(headerWrapper.childNodes);
            }
            tdDatas.push({ date: dates[0], type: type, className: [cls], colSpan: dates.length * colspan, template: htmlCol });
        }
        return tdDatas;
    }
    generateColumnLevels(dateSlots, hourSlots) {
        const levels = [];
        const rows = this.parent.activeViewOptions.headerRows;
        let lastLevelColspan = 1;
        if (rows[rows.length - 1].option === 'Hour' && hourSlots.length > 0) {
            lastLevelColspan = hourSlots.length / dateSlots.length;
        }
        let tdDatas = [];
        let byYear;
        let byMonth;
        let byWeek;
        for (const row of rows) {
            switch (row.option) {
                case 'Year':
                    byYear = this.groupByYear(this.renderDates);
                    tdDatas = this.generateSlots(byYear, lastLevelColspan, row, 'e-header-year-cell', 'yearHeader');
                    levels.push(tdDatas);
                    break;
                case 'Month':
                    byMonth = this.groupByMonth(this.renderDates);
                    tdDatas = this.generateSlots(byMonth, lastLevelColspan, row, 'e-header-month-cell', 'monthHeader');
                    levels.push(tdDatas);
                    break;
                case 'Week':
                    byWeek = this.groupByWeek(this.renderDates);
                    tdDatas = this.generateSlots(byWeek, lastLevelColspan, row, 'e-header-week-cell', 'weekHeader');
                    levels.push(tdDatas);
                    break;
                case 'Date':
                    tdDatas = dateSlots;
                    tdDatas = tdDatas.map((value) => {
                        value.colSpan = lastLevelColspan;
                        return value;
                    });
                    levels.push(tdDatas);
                    break;
                case 'Hour':
                    if (hourSlots.length > 0) {
                        levels.push(hourSlots);
                    }
                    break;
            }
        }
        return levels;
    }
}
